<ng-container *ngIf="loading; else viewTemplate">
  <div fxLayout="row" fxLayoutAlign="center center" class="height-50vh">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewTemplate>
  <div class="width-100 height-100 preview-pane-container">
    <div *ngIf="slug && entityType === 'publications'">
      <uni-publication-panel
        [publication]="entity">
      </uni-publication-panel>
    </div>

    <div *ngIf="slug && entityType === 'neo_projects'">
      <uni-project-panel
        [slug]="slug"
        [uuid]="projectVersion">
      </uni-project-panel>
    </div>

    <div *ngIf="slug && entityType === 'blogs' && entity">
      <uni-blog-panel
        [blog]="entity">
      </uni-blog-panel>
    </div>

    <div class="margin-top-4 margin-bottom-3" *ngIf="entity">
      <section class="share-like-footer" fxLayout="row" fxLayoutAlign="space-around center" fxLayoutAlign.lt-sm="space-between center">
          <uni-like-button 
            [source]="entityType" 
            [item]="entity" 
            [border]="true" 
            [showCount]="true">
          </uni-like-button>
  
        <div class="footer-grid">
          <uni-share-button-group
            [source]="entityType"
            [item]="entity"
            [content]="sharedContent"
            [slug]="entity?.slug"
            [report]="entity?.report" 
            [following]="entity?.is_following"
            [user]="user" 
            [self]="self" 
            [sourceCopy]="entityCopyLink">
          </uni-share-button-group>
        </div>
      </section>
    </div>

    <mat-divider class="width-100"></mat-divider>

    <div class="margin-top-3 margin-bottom-4">
      <uni-comment-group
        [source]="entityType"
        [slug]="slug"
        [uuid]="projectVersion">
      </uni-comment-group>
    </div>
  </div>
</ng-template>
